module.exports = __webpack_public_path__ + "static/mr-concert-performance-34-ba1bd1960adb771e1917dac89d0b2c55.jpg";